import React from 'react';
import { StatementOCRUploadTabLayout } from './StatementOCRUploadTab.styles';
import { PlaidOcrBpaUpload } from './PlaidOcrBpaUpload';
import { MicroFrontend } from 'micro-frontend';
import { useQuery } from '@apollo/client';
import { useClient } from '../../ClientContext';
import { NullState } from 'bench-internal-theme';
import { WrappedSpinner } from '../../../spinner';
import { GET_LEDGER_ACCOUNTS } from '../queries';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';
import { SplitFeatureFlags } from 'bk-web-app/features';

const StatementOCRUploadTab = () => {
  const client = useClient();
  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features, loading: featuresLoading },
  } = featureState;

  const {
    loading,
    error,
    data: ledgerAccountData,
  } = useQuery(GET_LEDGER_ACCOUNTS, {
    variables: { clientId: client?.id },
  });

  if (error) {
    return (
      <NullState
        bigEmoji="🙈"
        title="Uh oh! An error was encountered while fetching the data for this page."
      />
    );
  }

  if (loading || featuresLoading) {
    return <WrappedSpinner />;
  }

  const ledgerAccounts = ledgerAccountData?.ledgerAccounts || [];
  const filteredLedgerAccounts = ledgerAccounts.filter(
    ledgerAccount => !!ledgerAccount.active && !!ledgerAccount.role,
  );

  const data = {
    ledgerAccounts: filteredLedgerAccounts,
    businessId: client?.id,
    showRealTimeDataDisabledWarning:
      features[SplitFeatureFlags.BRAVEHEART_FOUNDATIONS]?.value !== FeatureValue.FEATURE_ON,
  };

  const isBPlaidOcrBpaUploadMigrated =
    features[SplitFeatureFlags.PLAID_OCR_BPA_UPLOAD_MIGRATED]?.value !== FeatureValue.FEATURE_ON;
  return (
    <StatementOCRUploadTabLayout>
      {isBPlaidOcrBpaUploadMigrated ? (
        <PlaidOcrBpaUpload />
      ) : (
        <MicroFrontend name="PlaidOcrBpaUpload" data={data} height="fill" />
      )}
    </StatementOCRUploadTabLayout>
  );
};

export default StatementOCRUploadTab;
